<template>
  <main>
    <section class="bg-h-primary-50 border py-2">
      <div class="container mx-auto">
        <BreadcrumbComponent :home="home" :items="items" />
      </div>
    </section>
    <section
      class="container mx-auto flex w-12/12 sm:w-10/12 lg:w-6/12 justify-center my-10"
    >
      <div class="w-full">
        <NewMaterialForm v-if="type === 'add' || type === 'edit'" />
        <!-- <SelectMaterialForm v-if="type === 'select'" /> -->
      </div>
    </section>
  </main>
</template>

<script lang="ts">
import { Chapter } from "@/models/chapter.model";
import {
  getItemLocalStorage,
  removeItemLocalStorage
} from "@/utils/save-storage.util";
import { defineComponent } from "@vue/runtime-core";
import { defineAsyncComponent } from "vue";

const NewMaterialForm = defineAsyncComponent(
  () => import("./FormType/new-material.vue")
);

const SelectMaterialForm = defineAsyncComponent(
  () => import("./FormType/select-material.vue")
);

export default defineComponent({
  name: "formMaterial",
  components: { NewMaterialForm, SelectMaterialForm },
  data() {
    return {
      type: this.$route.params?.type,
      home: {
        label:
          this.getChapterName()?.name ??
          this.$t("labels.generic", { pt: "Objeto", en: "Objective" }),
        command: () => this.$router.go(-1),
      },
      items: [
        {
          label:
            this.$route.params?.type == "add"
              ? this.$t("labels.generic", {
                  pt: "Novo objeto",
                  en: "New object",
                })
              : this.$t("labels.generic", {
                  pt: "Editar objeto",
                  en: "Edit object",
                }),
        },
      ],
    };
  },
  watch: {
    $route() {
      removeItemLocalStorage("objective");
    },
  },
  methods: {
    getChapterName(): Chapter {
      return JSON.parse(getItemLocalStorage("objective") as string);
    },
  },
});
</script>
